// extracted by mini-css-extract-plugin
module.exports = {"modal":"tQ","modalContent":"uQ","modalOverlay":"vQ","copy":"wQ","modalBtnContainer":"xQ","btnStay":"yQ","disabled":"zQ","btnContinue":"AQ"};